import indexOf from 'lodash/indexOf';
import storageHelper from './localStorageHelper';
import { unauthenticatedRouteNames, routesWithInfinitSession } from './constants';
import { history, store } from '../boot-client';
import cookieHelper from './cookieHelper';


/**
 * Autentication related helper functions
 */
const authHelper = {

    getAccessTokenData: () => {
        const { 'openIDIssuer': openIdIssuer, openIDClientID } = storageHelper.nonEncrypted.getItem('environmentProperties') || {};
        const authTokens = storageHelper.nonEncrypted.getItem(`authenticated_user:${openIdIssuer}:${openIDClientID}`) || {};
        return authTokens;
    },

    getAccessToken: () => {
        const authTokens = authHelper.getAccessTokenData();
        return authTokens?.access_token;
    },

    /**
     * Get token expiration dates
     */
    getTokensData: () => {
        const authTokens = authHelper.getAccessTokenData();
        return authTokens?.access_token ? authTokens : null;
    },

    /**
    * Get summed validity of all tokens
    */
    areAllTokensValid: () => {
        const authTokens = authHelper.getAccessTokenData();
        const tokens = authTokens?.access_token ? authTokens : null;

        if (!tokens) {
            return false;
        }
        const currentDate = Math.floor(Date.now() / 1000);
        const secondsUntilExpiration = tokens.expires_at - currentDate;

        return secondsUntilExpiration > 0;
    },

    //Need to perform cleanup also if local storage user is present, but userManager is not
    //Otherwise you will always get notification on the login page about being force logged out.
    forceLogoutUser: () => {
        const userManager = store.getState().portal.userManager;
        const user = storageHelper.getItem('user');
        const performCleanup = !!userManager || !!user;

        if (userManager) {
            userManager.removeUser();
        }
        if (user) {
            storageHelper.removeItemForUser('broadcastedMessage');
            storageHelper.removeItem('user');
            storageHelper.removeItem('authTokens');
            storageHelper.removeItem('loginTimestamp');
            storageHelper.removeItem('measurementUnitGroups');
            storageHelper.nonEncrypted.removeItem('environmentProperties');
        }

        return performCleanup;
    },

    doesPageNeedAuth: (pathname) => {
        return indexOf(unauthenticatedRouteNames, pathname) === -1;
    },

    doesPageNeedTokenRefresh: (pathname) => {
        return indexOf(routesWithInfinitSession, pathname) === -1;
    },

    redirectToLogin: (pathname) => {
        history.push('/Login?returnUrl=' + pathname + history.location.search);
    },

    logout: () => {
        const userManager = store.getState().portal.userManager;
        const currentRoute = history.location.pathname + history.location.search;

        cookieHelper.removeCookie('userLanguage');
        storageHelper.removeItem('user');
        storageHelper.removeItem('authTokens');
        storageHelper.removeItem('loginTimestamp');
        storageHelper.removeItem('measurementUnitGroups');
        storageHelper.setItem('returnUrl', currentRoute);

        userManager?.signoutRedirect();
    }
};

export default authHelper;
